/*SYSTEM IMPORTS*/
    import React/*, { Component }*/ from 'react'
    import classNames from 'classnames'

const Root = props => (
    <div className={ classNames( "root", props.className ) }>
        { props.children }
    </div>
)

export default Root